import React from "react";
import { UIText } from "@pfs/react-ui-kit";
import { useTranslation } from "src/hooks/useTranslation";
import { TEXT_TAGS, EVENT_NAME, EVENT_SCREEN, API_RESULT } from "src/utils/enums";
import { logPfsAnalyticsEvent } from "@/utils/helpers";
import "./MastercardDisclaimer.scss";

const TERMS_URL =
  "https://www.passportcard.co.il/financial-services/terms-of-use/";
const RATES_URL =
  "https://www.passportcard.co.il/financial-services/service-rates-agreement/";

export interface MastercardDisclaimerProps {
  textClassName?: string;
  eventScreen: EVENT_SCREEN;
}

const MastercardDisclaimer: React.FC<MastercardDisclaimerProps> = ({
  textClassName,
  eventScreen,
}) => {
  const { t } = useTranslation();

  return (
    <UIText
      text={
        <>
          {t("eligibleWebsites.mastercardDisclaimerPrefix")}
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mastercard-disclaimer__link"
            onClick={() => logPfsAnalyticsEvent({
              event_name: EVENT_NAME.LINK_CLICK,
              event_screen: eventScreen,
              status: API_RESULT.SUCCEEDED,
              link: { link_url: TERMS_URL, link_name: "terms_of_use" },
            })}
          >
            {t("eligibleWebsites.mastercardDisclaimerTermsLink")}
          </a>
          {t("eligibleWebsites.mastercardDisclaimerMiddle")}
          <a
            href={RATES_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mastercard-disclaimer__link"
            onClick={() => logPfsAnalyticsEvent({
              event_name: EVENT_NAME.LINK_CLICK,
              event_screen: eventScreen,
              status: API_RESULT.SUCCEEDED,
              link: { link_url: RATES_URL, link_name: "service_rates" },
            })}
          >
            {t("eligibleWebsites.mastercardDisclaimerRatesLink")}
          </a>
          {t("eligibleWebsites.mastercardDisclaimerSuffix")}
        </>
      }
      tag={TEXT_TAGS.P}
      size={12}
      weight={400}
      style={textClassName}
    />
  );
};

export default MastercardDisclaimer;
